import { Link } from 'react-router-dom';
import { useUi } from '../i18n/uiTranslations';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { SERVICE_VISUALS } from './ServiceVisuals';
import { SceneSection } from './Journey';

const CHAPTERS = [
  { key: 'aggregator', link: '/services/aggregator' },
  { key: 'platform', link: '/services/platform' },
  { key: 'payments', link: '/services/payments' },
  { key: 'crypto', link: '/services/crypto' },
];

const Chapter = ({ c, i, t }) => {
  const u = useUi();
  const Visual = SERVICE_VISUALS[c.key];
  return (
    <SceneSection scene={i + 2} id={i === 0 ? 'services' : `service-${c.key}`} testId={`service-chapter-${c.key}`} staticVisual={<div className="aspect-square w-[min(88vw,var(--band))] lg:w-full mx-auto"><Visual active /></div>}>
      {i === 0 && <p className="eyebrow mb-10" data-testid="services-title">{t('services.label')} — {t('services.title')}</p>}
      <div className="flex items-center gap-4 font-mono-lux text-[0.72rem] tracking-[0.14em]" data-testid={`chapter-${i + 1}-indicator`}>
        <span className="text-[#C8AA73]">0{i + 1}</span>
        <span className="h-px w-10 bg-[#C8AA73]/50" />
        <span className="text-[#7C776E]">04</span>
      </div>
      <h3 className="display-xl mt-7 text-[clamp(2.5rem,5vw,5.2rem)] break-words" data-testid={`service-card-${c.key}`}>
        {t(`services.${c.key}.title`)}
      </h3>
      <p className="mt-7 max-w-[440px] text-base sm:text-lg leading-relaxed text-[#ABA59A]">{t(`services.${c.key}.desc`)}</p>
      <Link to={c.link} className="btn-secondary mt-10 group min-h-[48px]" data-testid={`service-learn-more-${c.key}`}>
        {u('learnMore')}
        <ArrowRight className="w-4 h-4 transition-transform duration-500 group-hover:translate-x-1" strokeWidth={1.5} />
      </Link>
    </SceneSection>
  );
};

export const ServicesSection = () => {
  const { t } = useLanguage();
  return (
    <div data-testid="services-section">
      {CHAPTERS.map((c, i) => <Chapter key={c.key} c={c} i={i} t={t} />)}
    </div>
  );
};
